"use client";

function Icon({ name, className = "" }: { name: string; className?: string }) {
  return <span className={`material-symbols-outlined ${className}`}>{name}</span>;
}

const STEPS = [
  { num: "01", icon: "send", ar: "أرسل طلبك", en: "Submit request", dAr: "املأ النموذج ببيانات وحدتك خلال دقائق.", dEn: "Fill the form with your property details in minutes." },
  { num: "02", icon: "verified_user", ar: "المراجعة والتحقق", en: "Review & verify", dAr: "يتواصل فريقنا معك للتحقق من التفاصيل.", dEn: "Our team contacts you to verify the details." },
  { num: "03", icon: "publish", ar: "التشغيل والربح", en: "Operate & earn", dAr: "تُنشر وحدتك وتبدأ باستقبال الحجوزات.", dEn: "Your property goes live and starts getting bookings." },
];

export default function HowItWorksSection({ isAr }: { isAr: boolean }) {
  const t = (a: string, e: string) => (isAr ? a : e);
  return (
    <section className="najdi bg-clay-50 py-20 md:py-24" dir={isAr ? "rtl" : "ltr"}>
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-clay-600">
            {t("كيف", "How")} <span className="text-ink-900">{t("تعمل المنصّة", "it works")}</span>
          </h2>
        </div>

        <div className="relative flex flex-col md:flex-row justify-between gap-8 md:gap-12">
          <div aria-hidden className="hidden md:block absolute top-1/2 inset-x-0 h-0 border-t-2 border-dashed border-clay-100 -z-10 -translate-y-1/2" />
          {STEPS.map((step) => (
            <div key={step.num} className="flex-1 bg-surface rounded-2xl p-8 text-center shadow-sm hover:shadow-md transition-all">
              <div className="relative inline-block mb-6">
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-clay-600/15 font-display text-7xl font-extrabold select-none">
                  {step.num}
                </span>
                <div className="relative w-20 h-20 bg-clay-100 rounded-2xl flex items-center justify-center mx-auto">
                  <Icon name={step.icon} className="text-clay-600 text-4xl" />
                </div>
              </div>
              <h3 className="font-bold text-xl mb-2 text-ink-900">{t(step.ar, step.en)}</h3>
              <p className="text-sm text-ink-500 leading-relaxed">{t(step.dAr, step.dEn)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
